module.exports = __webpack_public_path__ + "img/maintenance.20b05989.svg";